// @flow

export const SET_PENDING_STATUS = 'PendingStatus/SET_PENDING_STATUS';
export const SET_SAVING_STATUS = 'PendingStatus/SET_SAVING_STATUS';
